export * from './interfaces/data-table-config.interface';
export * from './data-table.component';
